/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ZendeskIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <path d="M14.977 11.238v14.56H2.982l11.995-14.56Zm0-5.251a6.01 6.01 0 0 1-6.027 6.027c-3.342 0-5.968-2.686-5.968-6.027h11.995Zm1.97 19.752a6.01 6.01 0 0 1 6.026-6.027A6.01 6.01 0 0 1 29 25.739H16.946Zm0-5.192V5.987H29l-12.054 14.56Z" />
  </BaseIcon>
);
